// extracted by mini-css-extract-plugin
export default {"root":"RoleManage_root__DMmFO"};